import { render, staticRenderFns } from "./CreateDesignation.vue?vue&type=template&id=49b12648&scoped=true"
import script from "./CreateDesignation.vue?vue&type=script&lang=js"
export * from "./CreateDesignation.vue?vue&type=script&lang=js"
import style0 from "./CreateDesignation.vue?vue&type=style&index=0&id=49b12648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b12648",
  null
  
)

export default component.exports